// Typelizer digest ea00bd0f790aa940f9bc2b14b085f4ce
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/documents/:document_id/review_decisions */
  create: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/review_decisions', params, options),
    method: 'post',
  }),
}
